import { cn } from '@repo/ui';
import type { ReactElement, ReactNode } from 'react';

interface PageHeadingProps {
  readonly title: ReactNode;
  /** 제목 아래 한 줄 설명 — 없으면 제목만 선다. */
  readonly description?: ReactNode;
  readonly className?: string;
}

/** 화면 제목(h1) — HOME 섹션 제목과 같은 가는 큰 글자 결. */
export const PageHeading = ({ title, description, className }: PageHeadingProps): ReactElement => (
  <div className={cn('flex flex-col gap-3', className)}>
    <h1 className="text-[2rem] leading-[1.15] font-light tracking-[-0.03em] text-balance sm:text-5xl">
      {title}
    </h1>

    {description === undefined ? null : (
      <p className="text-sm text-muted-foreground">{description}</p>
    )}
  </div>
);
